"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.categoryPageClasses = void 0;
var _mui = require("@ori-ui/mui");
const categoryPageClasses = exports.categoryPageClasses = (0, _mui.generateUtilityClasses)('CategoryPage', [
    'description',
    'topBanner',
    'categoriesSection',
    'articlesSection'
]);
